module.exports = __webpack_public_path__ + "static/media/anschlussservice.a57bf205.svg";